import React from 'react';
import PlanningCapitalProjectsContainer from 'components/planning/capital-projects/PlanningCapitalProjectsContainer';

export const CapitalProjectsSection = ({
    entityCode,
}: {
    entityCode: string;
}) => {
    return (
        <div data-test="property-profile-capital-projects-section">
            <PlanningCapitalProjectsContainer entityCode={entityCode} />
        </div>
    );
};
